<template>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12">
          <v-img
            :src="require('../assets/logo.jpg')"
            class="my-3"
            contain
            height="200"
          />
        </v-col>
        <v-col>
        <login />
        </v-col>
      </v-row>
    </v-container>
</template>
<style scoped="true">

</style>
<script>
import Login from "@/components/UserLogin";
export default {
  name: "Welcome",
  components: {
    login: Login
  },
  data: () => ({})
};
</script>
